// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Il-z","articleImagesWrap":"Jl-z","articleImage":"Kl-z","singleImage":"Ll-z"};